<template>
  <div class="crumbs">
    <div>
      <h4>{{ title }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "crumbs",
  props: ["title"]
};
</script>

<style lang="less">
.crumbs {
  margin-bottom: 10px;
  background: #fff;
  div {
    box-sizing: border-box;
    height: 50px;
    padding: 10px 0 0 30px;
    h4 {
      height: 30px;
      padding-left: 15px;
      border-left: 3px solid #409eff;
      line-height: 30px;
      font-weight: normal;
    }
  }
}
</style>
